import { actionType } from "./actions";

let initialState = {
  initPageFinish: false, // loading login by token on first load
  isLoggedIn: false,
  isMerchantSelected: false,
  user: {},
};

function auth(state = initialState, action) {
  switch (action.type) {
    case actionType.LOGIN:
      return {
        ...state,
        user: action.user,
        initPageFinish: true,
        isLoggedIn: true,
      };
    case actionType.LOGIN_MERCHANT_SELECTED:
      return {
        ...state,
        user: action.user,
        initPageFinish: true,
        isLoggedIn: true,
        isMerchantSelected: true,
      };
    case actionType.INIT_PAGE_FINISH:
      return {
        ...state,
        isLoggedIn: false,
        isMerchantSelected: false,
        initPageFinish: true,
      };
    case actionType.LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        isMerchantSelected: false,
        initPageFinish: true,
      };
    default:
      return state;
  }
}

export default auth;
